import { post ,postfile,get} from './http'

//直播相关
export const getLiveList = v => post('/api/admin/findLiveAll', v.data, v.success, v.error); //获取直播列表

export const getLiveInfo = v => post('/api/admin/kmc/live/getLiveInfo', v.data, v.success, v.error); //获取单个直播信息 改

export const deleteLive = v => post('/api/admin/kmc/live/deleteLivebyInnerid', v.data, v.success, v.error); //删除直播 改

export const endLive = v => post('/api/admin/kmc/live/endLivebyInnerid', v.data, v.success, v.error); //结束直播 改

export const doSaveLive = v => postfile('/api/admin/kmc/live/saveAndupdateLive', v.data, v.success, v.error); //新建,编辑直播 改

export const getLiveNumber = v => postfile('/api/admin/kmc/live/findLiveNumber', v.data, v.success, v.error); //获取直播数量ß 改


//媒体报道

export const doSaveMediaReport = v => post('/api/admin/kmc/media/saveAndUpdateCwLivecontentMediainfo', v.data, v.success, v.error); //新建,编辑媒体报道 改

export const getMediaReport = v => get(`/api/admin/kmc/media/getCwLivecontentMediainfo/${v.liveinnerid}/${v.currentPage}/${v.pageSize}`, v.data, v.success, v.error); //获取媒体报道列表 改

export const delMediaReport = v => post(`/api/admin/kmc/media/deleteCwLivecontentMediainfoById`, v.data, v.success, v.error); //获取媒体报道列表 改

export const getCwLivecontentMediainfoById = v => post(`/api/admin/kmc/media/getCwLivecontentMediainfoById`, v.data, v.success, v.error); //媒体单个查询 新增


//装饰

// export const getDecorateList = v => get(`/api/admin/kmc/conlumn/getCwLivetvcolumninfo/${v.liveinnerid}`, v); //获取装饰列表 改
export const getDecorateList = v => post(`/api/admin/kmc/conlumn/getCwLivetvcolumninfo`, v.data, v.success, v.error); //获取装饰列表 改

export const doSaveDecorate = v => post(`/api/admin/kmc/conlumn/saveAndUpdateCwLivetvcolumninfo`, v.data, v.success, v.error); //添加栏目 改

export const delDecorate = v => post(`/api/admin/kmc/conlumn/deleteCwLivetvcolumninfoById`, v.data, v.success, v.error); //删除栏目 改

export const getInfoDecorate = v => post(`/api/admin/kmc/conlumn/getCwLivetvcolumninfoById`, v.data, v.success, v.error); //获取单个栏目详情 改

export const findColumnTypeList = v => post(`/api/admin/kmc/conlumn/findColumnTypeList`, v.data, v.success, v.error); //查询 栏目 类型 新增



//直播台  嘉宾风采

export const getPosterList = v => post(`/api/admin/kmc/post/findLivePostertAll`, v.data, v.success, v.error); //获取海报列表 改

export const delPoster = v => post(`/api/admin/kmc/post/deletePosterbyInnerid`, v.data, v.success, v.error); //删除单个海报 改

export const getPosterTeml = v => post(`/api/admin/kmc/post/findLivePostertemplateconfig`, v.data, v.success, v.error); //获取海报模板类型列表 改

export const doSavePoster = v => postfile(`/api/admin/kmc/post/saveNewPostersLive`, v.data, v.success, v.error); //新增海报类型 改

export const doSavePosterByHand = v => postfile(`/api/admin/kmc/post/saveUploadPosters`, v.data, v.success, v.error); //手动新增海报 改

export const makeliveposter = v => postfile(`/api/admin/kmc/post/makeliveposter`, v.data, v.success, v.error); //生成直播活动海报信息 新增

export const makeliveposterautofit = v => postfile(`/api/admin/kmc/post/makeliveposterautofit`, v.data, v.success, v.error); //生成直播活动海报信息 自适应  新增

export const saveliveposter = v => postfile(`/api/admin/kmc/post/saveliveposter`, v.data, v.success, v.error); //保存直播活动海报信息 新增

//直播台  图文直播

export const delPicturetextLive = v => post(`/api/admin/kmc/live/imagetext/deletemagetextbyInnerid`, v.data, v.success, v.error); //图文直播删除 改

export const getPicturetextList = v => post(`/api/admin/kmc/live/imagetext/findimagetextAll`, v.data, v.success, v.error); //图文直播查询 改

// export const getUEditorConfig = v => postfile(`/api/admin/kmc/live/imagetext/getUEditorConfig`, v); //获取百度编辑器配置信息 改

export const saveImagetextinfo = v => post(`/api/admin/kmc/live/imagetext/saveImagetextinfo`, v.data, v.success, v.error); //保存图文直播信息 改

// export const uploadLiveContentImage = v => postfile(`/api/admin/kmc/live/imagetext/uploadLiveContentImage`, v); //上传直播内容中的编辑器中的图片 改


